export default __webpack_public_path__ + "static/media/1011.59e87509.png";